<template>
  <!--角色管理 -->
  <div class="newsPage">
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>审核状态：</div>
          <el-select v-model="examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable
                     placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':'0','value':'审核中'},{'key':'1','value':'审核通过'},{'key':'2','value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <div>所属菜单：</div>
          <el-select v-model="menu" size="small" style="width: 180px;margin-right: 10px" clearable
                     placeholder="请选择所属菜单">
            <el-option
                v-for="item in [{'key':1,'value':'入围产品'},{'key':2,'value':'品牌介绍'},{'key':3,'value':'最终结果'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <div>新闻标题：</div>
          <el-input clearable placeholder="请输入搜索内容" size="small" style="width: 180px;margin-right: 10px"
                    v-model="newsTitle"></el-input>
          <el-button size="small" type="primary" @click="searchBtn">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
          <el-button size="small" type="success" @click="addBtn">新增</el-button>
          <el-button v-if="multipleSelection&&multipleSelection.length" @click="batchDeleteBtn" size="small"
                     type="danger">批量删除
          </el-button>
        </div>

        <el-table
            size="small"
            tooltip-effect="dark"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            :data="tableData"
            border
            style="width: 100%;margin-top: 30px"
        >
          <el-table-column
              type="selection"
              align="center"
              width="55">
          </el-table-column>
          <el-table-column label="新闻标题" width="230" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{ scope.row.news_title }}
                </template>
                <span
                    style="width:210px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{
                    scope.row.news_title
                  }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="摘要" width="230" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{ scope.row.zhaiyao }}
                </template>
                <span
                    style="width:210px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{
                    scope.row.zhaiyao
                  }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="封面图" align="center" width="140">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-image
                    style="width: 157px; height: 95px"
                    :src="scope.row.img_url"
                    :preview-src-list="scope.row.img_urlList">
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="置顶封面图" align="center" width="120">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-image v-if="scope.row.top_img_url"
                          style="width: 108px; height: 133px"
                          :src="scope.row.top_img_url"
                          :preview-src-list="scope.row.top_img_urlList">
                </el-image>
                <div v-else>暂无</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="是否登顶" width="80" prop="type" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.is_hot === '0' ? '否' : '是' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="所属菜单" width="80" prop="type" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.menu === 1 ? '入围产品' : scope.row.menu === 2 ? '品牌介绍' : '最终结果' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="新闻类型" width="80" prop="type" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.type === '1' ? '文本' : '视频' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="阅读人数" width="80" prop="watch_count" align="center"></el-table-column>
          <el-table-column header-align="center" width="120" label="审核状态">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-tag v-if="scope.row.examine_status === '0'" type="warning" size="small" effect="dark">审核中</el-tag>
                <el-tag v-if="scope.row.examine_status === '1'" type="success" size="small" effect="dark">审核通过</el-tag>
                <el-tag v-if="scope.row.examine_status === '2'" type="danger" size="small" effect="dark">审核未通过</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="100" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{ scope.row.create_date }}
                </template>
                {{ scope.row.create_date_list[0] }}
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="操作"
              width="200"
          >
            <template slot-scope="scope">
              <el-button @click="viewBtn(scope.row)" size="small" type="success">预览</el-button>
              <el-button @click="editBtn(scope.row)"
                         v-if="scope.row.examine_status === '0' || scope.row.examine_status === '2' " size="small"
                         type="success">修改
              </el-button>
              <el-button @click="recommendBtn(scope.row)" size="small" type="primary">相关推荐</el-button>
              <el-button style="margin-top: 10px" @click="deleteBtn(scope.row)" size="small" type="danger">删除
              </el-button>
              <el-button @click="viewVideoBtn(scope.row)" style="margin-top: 10px" v-if="scope.row.type === '2'"
                         size="small" type="primary">播放
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>

    <a-modal
        :visible="addDialogState"
        cancel-text="取消"
        ok-text="确认"
        :title="dialogTitle"
        width="1000px"
        @cancel="addCancel"
        @ok="addSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="封面图片(314*190)" prop="imgUrl">
              <el-upload
                  :before-upload="imgUrlBeforeAvatarUpload"
                  :on-success="imgUrlHandleAvatarSuccess"
                  :show-file-list="false"
                  :action="uploadApiUrl"
                  class="coverClass cover-uploader">
                <img v-if="ruleForm.imgUrl" :src="ruleForm.imgUrl" class="cover">
                <i v-else class="el-icon-plus cover-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="ruleForm.isHot && ruleForm.isHot === '1'" label="置顶图片(108*133)" prop="topImgUrl">
              <el-upload
                  :before-upload="topImgUrlBeforeAvatarUpload"
                  :on-success="topImgUrlHandleAvatarSuccess"
                  :show-file-list="false"
                  :action="uploadApiUrl"
                  class="topcoverClass cover-uploader">
                <img v-if="ruleForm.topImgUrl" :src="ruleForm.topImgUrl" class="cover">
                <i v-else class="el-icon-plus cover-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="新闻标题" prop="newsTitle">
              <el-input v-model="ruleForm.newsTitle" style="width: 97%" size="small" placeholder="请输入新闻标题"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="新闻摘要" prop="zhaiyao">
              <el-input v-model="ruleForm.zhaiyao" type="textarea" :rows="5" style="width: 97%" size="small"
                        placeholder="请输入新闻摘要"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="所属菜单" prop="menu">
              <el-select :disabled="dialogTitle === '修改'" @change="menuChange" v-model="ruleForm.menu" size="small"
                         clearable placeholder="请选择所属菜单">
                <el-option
                    v-for="item in [{'key':1,'value':'入围产品'},{'key':2,'value':'品牌介绍'},{'key':3,'value':'最终结果'}]"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否置顶" prop="isHot">
              <el-select @change="hotChange" v-model="ruleForm.isHot" size="small" clearable placeholder="请选择是否置顶">
                <el-option
                    v-for="item in [{'key':'1','value':'是'},{'key':'0','value':'否'}]"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="新闻类型" prop="type">
              <el-select :disabled="true" @change="typeChange" v-model="ruleForm.type" size="small" clearable
                         placeholder="请先选择所属菜单">
                <el-option
                    v-for="item in [{'key':'1','value':'文本'},{'key':'2','value':'视频'}]"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item v-if="ruleForm.type === '1'" label="文本内容" prop="newsContent">
          <quill-editor ref="myQuillEditor" style="width: 97%;height: 400px;padding-bottom: 200px"
                        v-model="ruleForm.newsContent" :options="editorOption"/>
        </el-form-item>

        <el-form-item v-if="ruleForm.type === '2'" label="视频文件" prop="newsContent">
          <el-upload
              class="upload-demo"
              :before-upload="beforeVideoUpload"
              :action="uploadApiUrl"
              :on-success="videoUploadSuccess"
              :on-remove="videoUploadRemove"
              :file-list="videoData"
              multiple
              :limit="1">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>

      </el-form>
    </a-modal>

    <!--    删除的弹窗-->
    <a-modal
        title="提示"
        :visible="deleteDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="deleteCancel"
        @ok="deleteSubmit"
    >
      <div>{{ simpleDelete ? '是否删除该条记录？' : '是否删除当前所选中的记录？' }}</div>
    </a-modal>

    <a-modal
        :visible="videoDialogState"
        title="视频"
        width="1200px"
        @cancel="videoDialogCancel"
    >
      <template slot="footer">
        <a-button key="back" v-show="false">
          Return
        </a-button>
        <a-button @click="videoDialogCancel" key="submit" v-show="true">
          关闭
        </a-button>
      </template>
      <video-player class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions">
      </video-player>
    </a-modal>

    <a-modal
        title="相关推荐"
        :visible="recommendState"
        width="1000px"
        :closable="false"
    >
      <template slot="footer">
        <a-button key="back" v-show="false">
          Return
        </a-button>
        <a-button @click="recommendSubmit" key="submit" v-show="true">
          关闭
        </a-button>
      </template>
      <el-table
          size="mini"
          tooltip-effect="dark"
          ref="dataishave"
          :data="newsIsHave"
          border
          style="width: 100%;"
      >
        <el-table-column label="新闻标题(已添加)" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.news_title }}</div>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="操作"
            width="100"
        >
          <template slot-scope="scope">
            <el-button size="small" @click="newsRemoveBtn(scope.row)" type="danger">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 10px 0">
        <el-input size="small" v-model="dialogNewsTitle" style="width: 200px" placeholder="请输入新闻名称"></el-input>
        <el-button style="margin-left: 10px" size="small" type="primary" @click="getAllNews">查询</el-button>
        <el-button size="small" type="danger" @click="resetAllNews">重置</el-button>
      </div>
      <el-table
          size="mini"
          tooltip-effect="dark"
          ref="dataishave"
          :data="newsAllHave"
          border
          style="width: 100%;"
      >
        <el-table-column label="新闻标题(全部新闻)" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.news_title }}</div>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="操作"
            width="100"
        >
          <template slot-scope="scope">
            <el-button size="small" @click="newsAddBtn(scope.row)" type="primary">添加</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          style="display: flex;justify-content: center;margin-top: 20px"
          background
          @size-change="handleDialogSizeChange"
          @current-change="handleDialogCurrentChange"
          :current-page="dialogPage"
          :page-size="dialogSize"
          :page-sizes="[5]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="dialogTotal">
      </el-pagination>
    </a-modal>

  </div>
</template>
<script>
import {baseURL} from "@/api/config";
import 'quill/dist/quill.snow.css'
import {Quill, quillEditor} from 'vue-quill-editor'
import {container, ImageExtend, QuillWatch} from 'quill-image-extend-module'
import axios from "axios";
Quill.register('modules/ImageExtend', ImageExtend)
import * as imageConversion from 'image-conversion';
export default {
  components: {quillEditor},
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  data() {
    return {
      editorOption: {
        placeholder: '请输入资讯内容',
        modules: {
          ImageExtend: {
            loading: true,
            name: 'file',
            action: '',
            response: (res) => {
              if (res.success) {
                return res.entity
              }
            }
          },
          toolbar: {
            container: container,
            handlers: {
              'image': function () {
                QuillWatch.emit(this.quill.id)
              }
            }
          }
        }
      },
      dialogTitle: '',
      pageNum: 1,
      pageSize: 20,
      examineStatus: null,
      menu: null,
      newsTitle: '',
      tableData: [],
      totalElements: 0,//数据总数
      addDialogState: false,
      ruleForm: {
        id: null,
        employeeId: localStorage.getItem("loginId"),
        newsTitle: '',
        zhaiyao: '',
        imgUrl: '',
        topImgUrl: '',
        isHot: null,
        type: null,
        menu: null,
        newsContent: '',
        examineStatus: '0'
      },
      rules: {
        newsTitle: [{required: true, message: "请输入新闻标题", trigger: "blur"}],
        zhaiyao: [{required: true, message: "请输入新闻摘要", trigger: "blur"}],
        imgUrl: [{required: true, message: "请上传封面图片", trigger: "blur"}],
        topImgUrl: [{required: true, message: "请上传置顶图片", trigger: "blur"}],
        menu: [{required: true, message: "请选择所属菜单", trigger: "blur"}],
        isHot: [{required: true, message: "请选择置顶状态", trigger: "blur"}],
        type: [{required: true, message: "请选择新闻类型", trigger: "blur"}],
        newsContent: [{required: true, message: '视频或文本不能为空', trigger: "blur"}],
      },
      uploadApiUrl: '',
      simpleDelete: false,
      deleteId: null,
      deleteDialogState: false,
      multipleSelection: [],
      videoData: [],
      videoDialogState: false,
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: 'auto',
        language: 'zh-CN',
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: '16:9',
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [{
          //类型
          type: "video/mp4",
          //url地址
          src: ''
        }],
        //你的封面地址
        poster: '',
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true
        }
      },
      recommendState: false,
      currentId: null,
      currentMenu: null,
      newsIsHave: [],
      newsAllHave: [],
      dialogNewsTitle: '',
      dialogPage: 1,
      dialogSize: 5,
      dialogTotal: 0,
    };
  },
  mounted() {

  },
  methods: {
    viewVideoBtn(row) {
      this.playerOptions.sources[0].src = row.news_content
      this.videoDialogState = true
    },
    videoDialogCancel() {
      this.player.pause()
      this.videoDialogState = false
    },
    typeChange() {
      this.ruleForm.newsContent = ''
      this.videoData = []
    },
    menuChange() {
      if (this.ruleForm.menu) {
        if (this.ruleForm.menu === 2) {
          this.ruleForm.type = '2'
        } else {
          this.ruleForm.type = '1'

          setTimeout(() => {
            let quill = this.$refs.myQuillEditor.quill;
            quill.root.addEventListener(
                "paste",
                (evt) => {
                  if (
                      evt.clipboardData &&
                      evt.clipboardData.files &&
                      evt.clipboardData.files.length
                  ) {
                    evt.preventDefault();
                    [].forEach.call(evt.clipboardData.files, (file) => {
                      if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
                        return;
                      }
                      console.log('file',file)
                      imageConversion.compressAccurately(file, 500).then(res => {
                        const formData = new FormData();
                        formData.append("file", res);
                        axios.post(this.uploadApiUrl, formData).then(res => {
                              console.log('res', res)
                              let length = quill.getSelection().index; //光标位置
                              // 插入图片地址
                              quill.insertEmbed(length, "image", res.entity);
                              // 光标后移一位
                              quill.setSelection(length + 1);
                            });
                      });

                    });
                  }
                },
                false
            );
          }, 300)

        }
      } else {
        this.ruleForm.type = null
      }
      this.ruleForm.newsContent = ''
    },
    hotChange() {
      if (this.ruleForm.isHot === '0') {
        this.ruleForm.topImgUrl = ''
      }
    },
    uploadSuccess(res) {  //把已经上传的图片显示回富文本编辑框中
      //res返回的格式是{url:"图片的路径"}，这个是后台接口返回的
      let quill = this.$refs.myQuillEditor.quill
      quill.focus();
      quill.insertEmbed(quill.getSelection().index, 'image', res.entity);
    },
    beforeVideoUpload(file) {
      console.log('file', file)
      const isVideo = file.type === 'video/mp4';
      if (!isVideo) {
        this.$message.error('只能上传视频文件');
      }
      return isVideo;
    },
    videoUploadSuccess(res) {
      if (res.success) {
        this.ruleForm.newsContent = res.entity
      }
    },
    videoUploadRemove() {
      this.ruleForm.newsContent = ''
      this.videoData = []
    },
    searchBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.getNewsList()
    },
    resetBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.examineStatus = null
      this.menu = null
      this.newsTitle = ''
      this.getNewsList()
    },
    addBtn() {
      this.dialogTitle = '新增'
      this.ruleForm.id = null
      this.ruleForm.newsTitle = ''
      this.ruleForm.zhaiyao = ''
      this.ruleForm.imgUrl = ''
      this.ruleForm.menu = null
      this.ruleForm.isHot = null
      this.ruleForm.topImgUrl = ''
      this.ruleForm.type = null
      this.ruleForm.newsContent = ''
      this.videoData = []
      this.addDialogState = true
    },
    editBtn(row) {
      this.dialogTitle = '修改'
      this.ruleForm.id = row.id
      this.ruleForm.newsTitle = row.news_title
      this.ruleForm.zhaiyao = row.zhaiyao
      this.ruleForm.imgUrl = row.img_url
      this.ruleForm.menu = row.menu
      this.ruleForm.isHot = row.is_hot
      this.ruleForm.topImgUrl = row.top_img_url
      this.ruleForm.type = row.type
      this.ruleForm.newsContent = row.news_content
      if (this.ruleForm.type === '2') {
        this.videoData = []
        this.videoData.push({url: row.news_content, name: '视频文件'})
      }
      this.addDialogState = true
    },
    viewBtn(row) {
      this.$router.push({
        path: "/banshouliPreview", query: {
          id: row.id
        }
      });
    },
    deleteBtn(row) {
      this.simpleDelete = true
      this.deleteId = row.id
      this.deleteDialogState = true
    },
    batchDeleteBtn() {
      this.simpleDelete = false
      this.deleteDialogState = true
    },
    deleteCancel() {
      this.deleteDialogState = false
    },
    recommendBtn(row) {
      this.currentId = row.id
      this.currentMenu = row.menu
      this.getAxios("/handNewsInfo/getOneHandNewsInfoById?id=" + this.currentId, {}).then(res => {
        if (res && res.entity && res.entity.relevantEntitys && res.entity.relevantEntitys.length) {
          this.newsIsHave = res.entity.relevantEntitys
        } else {
          this.newsIsHave = []
        }
        this.recommendState = true
      })
      this.getAllNews();
    },
    resetAllNews() {
      this.dialogPage = 1
      this.dialogNewsTitle = ''
      this.getAllNews();
    },
    getAllNews() {
      this.postAxios("/handNewsInfo/getAllRelevant", {
        pageNum: this.dialogPage,
        pageSize: this.dialogSize,
        parameterMap: {
          newsTitle: this.dialogNewsTitle,
          menu: this.currentMenu
        }
      }).then(res => {
        if (res && res.content && res.content.length) {
          this.newsAllHave = res.content
          this.dialogTotal = res.totalCount
        } else {
          this.newsAllHave = []
          this.dialogTotal = 0
        }
      })
    },
    isHaveResfresh() {
      this.getAxios("/handNewsInfo/getOneHandNewsInfoById?id=" + this.currentId, {}).then(res => {
        if (res && res.entity && res.entity.relevantEntitys && res.entity.relevantEntitys.length) {
          this.newsIsHave = res.entity.relevantEntitys
        } else {
          this.newsIsHave = []
        }
      })
    },
    newsRemoveBtn(row) {
      this.postAxios("/handNewsInfo/delHandNewsInfoRelevantByIds", [row.id]).then(res => {
        if (res.success) {
          this.isHaveResfresh()
        }
      })
    },
    newsAddBtn(row) {
      if (this.newsIsHave.length === 4) {
        this.$message.error('最多能添加4条相关推荐!')
        return false;
      }
      this.postAxios("/handNewsInfo/addHandNewsInfoRelevantBatch", [
        {
          handNewsInfoId: this.currentId,
          relevantId: row.id
        }
      ]).then(res => {
        if (res.success) {
          this.isHaveResfresh()
        }
      })
    },
    recommendSubmit() {
      this.recommendState = false
    },
    deleteSubmit() {
      if (this.simpleDelete) {
        //单个删除
        this.postAxios("/handNewsInfo/delHandNewsInfoByIds", [
          this.deleteId
        ]).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.resetBtn()
          }
        })
      } else {
        //多个删除
        let ids = []
        this.multipleSelection.forEach((item) => {
          ids.push(item.id)
        })
        this.postAxios("/handNewsInfo/delHandNewsInfoByIds", ids).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.resetBtn()
          }
        })
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    addCancel() {
      this.addDialogState = false
      this.$refs.ruleForm.clearValidate();
    },
    addSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === '新增') {
            this.postAxios("/handNewsInfo/addHandNewsInfo", this.ruleForm).then(res => {
              if (res.success) {
                this.$message.success("添加成功!")
                this.addDialogState = false
                this.getNewsList()
              }
            });
          } else {
            this.postAxios("/handNewsInfo/updHandNewsInfoById", this.ruleForm).then(res => {
              if (res.success) {
                this.$message.success("修改成功!")
                this.addDialogState = false
                this.getNewsList()
              }
            });
          }
        }
      });
    },
    imgUrlHandleAvatarSuccess(res) {
      if (res.success) {
        this.ruleForm.imgUrl = res.entity;
      }
    },
    imgUrlBeforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    topImgUrlHandleAvatarSuccess(res) {
      if (res.success) {
        this.ruleForm.topImgUrl = res.entity;
      }
    },
    topImgUrlBeforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    getNewsList() {
      let url = '/handNewsInfo/getHandNewsInfoList'
      this.postAxios(url, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: {
          newsTitle: this.newsTitle,
          examineStatus: this.examineStatus === '' ? null : this.examineStatus,
          menu: this.menu === '' ? null : this.menu,
        }
      }).then(res => {
        if (res.success) {
          this.tableData = []
          this.tableData = res.content;
          this.tableData.forEach((item) => {
            item.img_urlList = []
            item.top_img_urlList = []
            item.create_date_list = item.create_date.split(' ')
            if (item.img_url) {
              item.img_urlList.push(item.img_url)
            }
            if (item.top_img_url) {
              item.top_img_urlList.push(item.top_img_url)
            }
          })
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getNewsList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getNewsList()
    },
    handleDialogSizeChange(val) {
      this.dialogSize = val
      this.getAllNews()
    },
    handleDialogCurrentChange(val) {
      this.dialogPage = val
      this.getAllNews()
    },
  },
  created() {
    this.uploadApiUrl = baseURL + '/file/uploadFile/v2'
    this.editorOption.modules.ImageExtend.action = this.uploadApiUrl
    this.getNewsList();
  }
};
</script>
<style lang="less" scoped>
.coverClass {
  .cover-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .cover-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .cover-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    border: 1px dashed #d9d9d9;
    width: 314px;
    height: 190px;
    line-height: 190px;
    text-align: center;
  }

  .cover {
    width: 314px;
    height: 190px;
    display: block;
  }
}

.topcoverClass {
  .cover-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .cover-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .cover-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    border: 1px dashed #d9d9d9;
    width: 108px;
    height: 133px;
    line-height: 133px;
    text-align: center;
  }

  .cover {
    width: 108px;
    height: 133px;
    display: block;
  }
}

</style>
